import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retryWithBackoff } from '../operators';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  static readonly retryHeaderName = 'App-maxRetry';
  static readonly retryStatusesHeaderName = 'App-retryStatuses';

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const maxRetry = Number(
      request.headers.get(RetryInterceptor.retryHeaderName)
    );
    const retryStatusesHeader = request.headers.get(RetryInterceptor.retryStatusesHeaderName);
    const retryableStatuses = retryStatusesHeader
      ? retryStatusesHeader.split(',').map(Number)
      : undefined;

    request = request.clone({
      headers: request.headers
        .delete(RetryInterceptor.retryHeaderName)
        .delete(RetryInterceptor.retryStatusesHeaderName),
    });
    return next.handle(request).pipe(retryWithBackoff(maxRetry, undefined, undefined, retryableStatuses));
  }
}
